import MembershipBusinessListResourcePagingResultModel from '../../generated/types/model/resource/MembershipBusinessListResourcePagingResultModel';

export default class MembershipBusinessListResourcePagingResultViewModel extends MembershipBusinessListResourcePagingResultModel {
  protected transformToDTO() {}
  protected transformFromDTO() {}
}
